import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const SkillCertService = {
  getAllSkillCert(obj) {
    return httpClient.post(endPoints.getAllSkillCert, obj);
  },
  getAllSkillCertByPagination(obj) {
    return httpClient.post(endPoints.getAllSkillCertByPagination, obj);
  },
  getAllSkillCertList(obj) {
    return httpClient.post(endPoints.getAllSkillCertList, obj);
  },
  getAnsType(obj) {
    return httpClient.post(endPoints.getAnsType, obj);
  },
  getSkillCertDetailByItem(obj) {
    return httpClient.post(endPoints.getSkillCertDetailByItem, obj);
  },
  addSkillCert(obj) {
    return httpClient.post(endPoints.addSkillCert, obj);
  },
  updateSkillCert(obj) {
    return httpClient.post(endPoints.updateSkillCert, obj);
  },
  deleteSkillCert(obj) {
    return httpClient.post(endPoints.deleteSkillCert, obj);
  },
};

export default SkillCertService;



// WEBPACK FOOTER //
// ./src/service/SkillCertService.js